/**
 * How the voucher timeline describes an adjustment that was created to be applied to the voucher's gift card
 * too (C2S-1324): waiting, applied (with what went on the card) or not applied (with why).
 */
import {EnumVoucherAdjustmentGiftCardSyncStatus, VoucherAdjustmentGiftCardSync} from "../../../Queries";

export enum GiftCardSyncTone {
   Waiting = 'waiting',
   Done = 'done',
   Failed = 'failed'
}

export type GiftCardSyncLabel = {
   text: string
   tone: GiftCardSyncTone
}

type GiftCardSync = Pick<VoucherAdjustmentGiftCardSync, 'status' | 'amount' | 'currency' | 'error'>;

/** The timeline line for an adjustment's gift card sync; undefined for an adjustment that was not meant for the card */
export const giftCardSyncLabel = (sync?: GiftCardSync | null): GiftCardSyncLabel | undefined => {
   if (!sync) {
      return undefined;
   }
   switch (sync.status) {
      case EnumVoucherAdjustmentGiftCardSyncStatus.APPLIED: {
         const amount = typeof sync.amount === 'number' && sync.currency
            ? ` (${sync.amount >= 0 ? '+' : '-'}${Math.abs(sync.amount).toFixed(2)} ${sync.currency})`
            : '';
         return {text: `Applied to the gift card${amount}`, tone: GiftCardSyncTone.Done};
      }
      case EnumVoucherAdjustmentGiftCardSyncStatus.FAILED:
         return {text: `Not applied to the gift card: ${sync.error || 'no reason given'}`, tone: GiftCardSyncTone.Failed};
      default:
         return {text: 'Waiting to be applied to the gift card', tone: GiftCardSyncTone.Waiting};
   }
}
